var map = {
	"./400.gif": 391,
	"./404.gif": 390,
	"./408.gif": 389,
	"./410.gif": 388,
	"./412.gif": 387,
	"./500.gif": 386,
	"./501.gif": 385,
	"./503.gif": 384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 392;